// extracted by mini-css-extract-plugin
module.exports = {"left-message":"app_left-message__VcSBq"};